
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-46/items",
      function () {
        return require("private-next-pages/info/set-46/items.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-46/items"])
      });
    }
  